//
//
//
//
//
//
//
//

import { Dialog } from 'vant'

export default {
    props: {
        dialogOptions: Object,
        placeholder: ''
    },
    data() {
        return { val: '' }
    },
    methods: {
        callback(action) {
            var { dialogOptions } = this
            if (this.$route.query.popup) history.back() //关闭
            //instance.$destroy()
            dialogOptions.calllback && dialogOptions.calllback(action)
            if (action === 'confirm') {
                this.$emit('confirm', this.val)
            } else {
                this.$emit('cancel', action);
            }
        }
    },
    computed: {
        options() {
            var options = Object.assign({}, Dialog.defaultOptions, {
                //message: vnode,
                showCancelButton: false,
                //showConfirmButton: false,
                className: 'app-popup',
            }, this.dialogOptions, {
                callback: this.callback
            })

            if (!options.title) options.title = '　'
            if (options.showCancelButton || options.showConfirmButton) options.className += ' popup-bbt'
            return options
        }
    }
}
